import React, {Component} from "react";

export const CommunityContext = React.createContext({});

export default class CommunityProvider extends Component {
  state = {
    content: "newFeed",
    setContent: (value: string) => {
      this.setState({ content: value });
    },

    groupData: {},
    setGroupData: (value: any) => {
      this.setState({ groupData: value });
    },

    members: null,
    setMembers: (value: any) => {
      this.setState({ members: value });
    },
  };
  componentDidMount() {
    try {
    } catch (e) {}
  }

  render() {
    return (
      <CommunityContext.Provider value={this.state}>
        {this.props.children}
      </CommunityContext.Provider>
    );
  }
}
//@ts-ignore
CommunityProvider.Consumer = CommunityContext.Consumer;
